import { RouterProvider } from 'react-router';
import { router } from './routes';
import { AuthProvider } from '@/context/AuthContext';
import { useWebMCP } from '@/hooks/useWebMCP';

function App() {
  useWebMCP();

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
